import React from "react";
import { Modal, Icon } from "../../";
import PluginSettingsConfig from "./PluginSettingsConfig";
import ApiKeyConfigField from "./ApiKeyConfigField";
import DeliverectSetupGuide from "./DeliverectSetupGuide";

const DELIVERECT_CATEGORY_KEY = "plugin_deliverect_integration";

const HIDDEN_CONFIG_KEYS = [
  "deliverect_integration_token",
  "deliverect_integration_token_expiration",
  "deliverect_integration_client_secret_dispatch",
  "deliverect_integration_client_id_dispatch",
  "deliverect_integration_token_dispatch",
  "deliverect_integration_token_expiration_dispatch",
];

const API_KEY_CONFIG_KEY = "deliverect_integration_api_key";

const PluginSettingsModal = ({
  isOpen,
  onClose,
  category,
  title = "Plugin Settings",
}) => {
  if (!isOpen) return null;

  const visibleConfigs =
    category?.configs?.filter(
      (config) => !HIDDEN_CONFIG_KEYS.includes(config.key),
    ) || [];

  const hasConfigs = visibleConfigs.length > 0;
  const isDeliverect = category?.key === DELIVERECT_CATEGORY_KEY;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      subtitle={category?.description}
      maxWidth="max-w-3xl"
    >
      <div className="space-y-4">
        {!category ? (
          <div className="flex flex-col items-center justify-center py-12 text-center">
            <Icon
              name="Settings"
              className="text-muted-foreground mb-4 h-12 w-12"
            />
            <h3 className="text-foreground mb-2 text-lg font-medium">
              No Settings Available
            </h3>
            <p className="text-muted-foreground text-sm">
              Plugin settings could not be loaded. Please try again.
            </p>
          </div>
        ) : hasConfigs ? (
          <div className="space-y-4">
            {visibleConfigs.map((config) =>
              config.key === API_KEY_CONFIG_KEY ? (
                <ApiKeyConfigField key={config.id} config={config} />
              ) : (
                <PluginSettingsConfig key={config.id} config={config} />
              ),
            )}

            {isDeliverect && <DeliverectSetupGuide />}
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center py-12 text-center">
            <Icon
              name="Settings"
              className="text-muted-foreground mb-4 h-12 w-12"
            />
            <h3 className="text-foreground mb-2 text-lg font-medium">
              No Settings Available
            </h3>
            <p className="text-muted-foreground text-sm">
              This plugin has no configurable settings.
            </p>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default PluginSettingsModal;
